var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "74px",
    viewBox: "0 0 64 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Forms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library---Forms---Create---From-Scratch-Copy-3",
    transform: "translate(-451.000000, -669.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(451.000000, 669.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#0075C9",
    strokeWidth: 1.5,
    x: 5.75,
    y: 10.75,
    width: 43.5,
    height: 62.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#0075C9",
    strokeWidth: 1.5,
    x: 8.75,
    y: 29.75,
    width: 17.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    stroke: "#0075C9",
    strokeWidth: 1.5,
    x: 8.75,
    y: 42.75,
    width: 37.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#0075C9",
    strokeWidth: 1.5,
    x: 28.75,
    y: 29.75,
    width: 17.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "ONLINE-FORM",
    fontFamily: "Lato,sans-serif",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#0075C9"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8
  }, "ONLINE FORM")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0075C9",
    x: 8,
    y: 15,
    width: 39,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#0075C9",
    x: 8,
    y: 36,
    width: 39,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#0075C9",
    x: 8,
    y: 19,
    width: 39,
    height: 4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineForm);
export default __webpack_public_path__ + "static/media/online-form.69991395.svg";
export { ForwardRef as ReactComponent };